import * as React from 'react'
import {useLocation} from 'react-router-dom'

import {useQueryParam} from '../../../../../../hooks/routes'
import {getAgentTypeHref, matchRoute, Routes} from '../../../../../../routes'
import {getCanViewAgentDetails} from '../../../../../../selectors'
import type {KeyValue} from '../../../../../../utils/object'
import SidebarLink, {
  InactiveSidebarLink,
} from '../../../../../common/Sidebar/SidebarLink/SidebarLink'
import LinearAgentType from '../../../components/LinearAgentType/LinearAgentType'
import type {AgentsTreeItemAgentType} from '../../AgentsSidebar.types'
import {AgentTreeItemCategory} from '../../AgentsSidebar.types'
import BusyAgentsCounter from '../../BusyAgentsCounter/BusyAgentsCounter'
import DisconnectedAgentsCounter from '../../DisconnectedAgentsCounter/DisconnectedAgentsCounter'
import {getAgentsTreeSearchState} from '../../selectors/getExpand'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = AgentsTreeItemAgentType & {
  className?: string | undefined
  style?: KeyValue<string, string | number>
}
export default React.memo(function AgentType({
  id,
  title,
  count,
  busyCount,
  disconnectedCount,
  className,
  style,
  category,
}: Props) {
  const canViewAgentDetails = useAppSelector(getCanViewAgentDetails)
  const tail =
    disconnectedCount > 0 ? <DisconnectedAgentsCounter count={disconnectedCount} /> : null
  let agentTypeHref = getAgentTypeHref(id, category === AgentTreeItemCategory.MAIN)
  const location = useLocation()
  const tab = useQueryParam('tab')

  if (matchRoute(Routes.CLOUD_IMAGE, location) != null && tab != null) {
    agentTypeHref = `${agentTypeHref}?tab=${tab}`
  }

  const {searchQuery} = useAppSelector(getAgentsTreeSearchState)
  const linkContent = (
    <>
      <LinearAgentType title={title} searchQuery={searchQuery} />
      <BusyAgentsCounter
        busyCount={busyCount}
        disconnectedCount={disconnectedCount}
        count={count}
      />
    </>
  )
  const linkProps = {className, style, tail}

  return canViewAgentDetails ? (
    <SidebarLink to={agentTypeHref} tabIndex={-1} {...linkProps}>
      {linkContent}
    </SidebarLink>
  ) : (
    <InactiveSidebarLink {...linkProps}>{linkContent}</InactiveSidebarLink>
  )
})
